import React, { useCallback, useState } from 'react'
import { Datagrid, DateField, NumberField, TextField } from 'react-admin'
import { FILTER_SOURCES } from 'services/cfg/filter'
import { transactionStatusChoices } from 'services/cfg/form'
import { getGeoLang } from 'services/geo-management'
import { optionsDate } from 'services/utils/date'
import BulkExportButtonWrapper from 'ui-shared/CustomButtons/BulkExportButtonWrapper'
import KFilters from 'ui-shared/KFilters'
import KPagination from 'ui-shared/KPagination'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import TransactionAsidePanel from './TransactionAsidePanel'
import AsideShowButton from './ShowAsidButton'
import { Drawer } from '@mui/material'
import KList from 'ui-shared/KWrappers/KList'
import { Transaction } from 'services/api/entities/accounting/transaction/types/internal/transaction-models'

const TransactionList: React.FC<BaseListProps> = (props) => {
  const [asideRecord, setAsideRecord] = useState<Transaction | undefined>(
    undefined
  )

  const handleAsideRecord = useCallback(
    (p?: Transaction) => {
      if (asideRecord?.id === p?.id) {
        setAsideRecord(undefined)
      } else {
        setAsideRecord(p)
      }
    },
    [asideRecord, setAsideRecord]
  )

  return (
    <SectionWrapper>
      <KList
        {...props}
        pagination={<KPagination />}
        perPage={40}
        exporter={false}
        filters={<KFilters />}
        filterDefaultValues={{
          [FILTER_SOURCES.eventStatus]: transactionStatusChoices[0].id,
        }}
      >
        <Datagrid
          rowClick="edit"
          bulkActionButtons={<BulkExportButtonWrapper />}
        >
          <NumberField
            source="id"
            label="form.fields.eventId"
            sortable={false}
          />
          <TextField source="customerName" sortable={false} />
          <TextField
            label="form.fields.email"
            source="customerEmail"
            sortable={false}
          />
          <TextField source="eventType" sortable={false} />
          <DateField
            source="eventDate"
            options={optionsDate}
            locales={getGeoLang()}
          />
          <TextField source="customerCluster" sortable={false} />
          <TextField source="invoiceStatus" sortable={false} />
          <TextField source="paymentMethod" sortable={false} />
          <TextField source="paymentStatus" sortable={false} />
          <TextField source="accountingStatus" sortable={false} />

          <AsideShowButton cb={handleAsideRecord} />
        </Datagrid>
      </KList>
      <Drawer variant="persistent" open={!!asideRecord} anchor="right">
        <TransactionAsidePanel
          record={asideRecord}
          handleClose={() => setAsideRecord(undefined)}
        />
      </Drawer>
    </SectionWrapper>
  )
}

export default TransactionList
